(function(){
  /* ═══ SCROLL BUTTONS ═══ */
  document.querySelectorAll('.jcbl-section__scroll-wrap').forEach(function(wrap){
    var grid = wrap.querySelector('.jcbl-section__grid');
    var left = wrap.querySelector('.jcbl-scroll-btn--left');
    var right = wrap.querySelector('.jcbl-scroll-btn--right');
    if(!grid||!left||!right) return;
    function update(){
      var sl=grid.scrollLeft, sw=grid.scrollWidth, cw=grid.clientWidth;
      left.hidden = sl < 10;
      right.hidden = sl + cw >= sw - 10;
    }
    left.addEventListener('click',function(){ grid.scrollBy({left:-340,behavior:'smooth'}); });
    right.addEventListener('click',function(){ grid.scrollBy({left:340,behavior:'smooth'}); });
    grid.addEventListener('scroll',update);
    window.addEventListener('resize',update);
    update();
  });

  /* ═══ VIDEO MODAL ═══ */
  var modal = document.getElementById('jcbVideoModal');
  var player = document.getElementById('jcbVideoPlayer');
  if(!modal||!player) return;

  var backdrop = modal.querySelector('.jcb-vmodal__backdrop');
  var closeBtn = modal.querySelector('.jcb-vmodal__close');

  function parseVideoUrl(url){
    // YouTube: youtube.com/watch?v=ID, youtu.be/ID, youtube.com/shorts/ID
    var m;
    m = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/shorts\/)([a-zA-Z0-9_-]+)/);
    if(m) return {type:'youtube', id:m[1]};
    // Vimeo: vimeo.com/ID
    m = url.match(/vimeo\.com\/(\d+)/);
    if(m) return {type:'vimeo', id:m[1]};
    // Direct video (mp4, webm)
    if(/\.(mp4|webm|ogg)/i.test(url)) return {type:'direct', url:url};
    // Fallback: try as direct
    return {type:'direct', url:url};
  }

  function openModal(videoUrl){
    var info = parseVideoUrl(videoUrl);
    if(info.type==='youtube'){
      player.innerHTML = '<iframe src="https://www.youtube-nocookie.com/embed/'+info.id+'?autoplay=1&rel=0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
    } else if(info.type==='vimeo'){
      player.innerHTML = '<iframe src="https://player.vimeo.com/video/'+info.id+'?autoplay=1" allow="autoplay; fullscreen" allowfullscreen></iframe>';
    } else {
      player.innerHTML = '<video src="'+info.url+'" controls autoplay playsinline></video>';
    }
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closeModal(){
    modal.hidden = true;
    player.innerHTML = '';
    document.body.style.overflow = '';
  }

  // Event listeners
  if(backdrop) backdrop.addEventListener('click', closeModal);
  if(closeBtn) closeBtn.addEventListener('click', closeModal);
  document.addEventListener('keydown', function(e){
    if(e.key==='Escape' && !modal.hidden) closeModal();
  });

  // Video card clicks
  document.querySelectorAll('.jcbl-card--video').forEach(function(card){
    function handleOpen(){
      var url = card.getAttribute('data-video-url');
      if(url) openModal(url);
    }
    card.addEventListener('click', handleOpen);
    card.addEventListener('keydown', function(e){
      if(e.key==='Enter'||e.key===' '){ e.preventDefault(); handleOpen(); }
    });
  });
})();
